class SoftLineBreak {
  clone() {
    return new SoftLineBreak();
  }
}

export default SoftLineBreak;
